const convertDate = (date) => {
  const newDate = new Date(date)
  return `${newDate.getUTCDate()} ${newDate.toLocaleString('default', { month: 'short', timeZone: 'UTC' })}, ${newDate.getUTCFullYear()}`;
};

export default convertDate;
